export enum FieldLocationEnum {
  ALL = 'All',
  Eu = 'eu',
  Us = 'us',
}
